app.controller('popupVisitDetailsController', ['$scope', '$state', '$mdDialog', '$timeout', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'userModel', 'visitModel', 'visitCardModel', 'visit', 'chronicAndPastIllnessModel', 'allergyModel', 'patientModel', 'config',
    function ($scope, $state, $mdDialog, $timeout, $translate, objectHelper, baseModel, applicationModel, userModel, visitModel, visitCardModel, visit, chronicAndPastIllnessModel, allergyModel, patientModel, config) {

        var listeners = {};

        function setData() {
            $scope.visit = visit;
            $scope.Enum = Enum;
            $scope.lastPatientVisit = null;
            $scope.chronicIllnesses = null;
            $scope.allergies = null;
            $scope.mainAfflictionFromLastVisit = null;
            $scope.patientId = visit.patient.id;
            $scope.user = userModel.currentUser;

            $scope.chronicAndPastIllnessCriteria = new ChronicAndPastIllnessDataGridCriteria();
            $scope.chronicAndPastIllnessCriteria.idPatient = visit.patient.id;

            $scope.allergyCriteria = new StateOfHealthDataGridCriteria();
            $scope.allergyCriteria.idPatient = visit.patient.id;

            var now = new Date();
            $scope.isTodayVisit = now.toDateString() == $scope.visit.date.toDateString();

            if (config.DEMO) {
                $scope.firstVisit = false;
            } else {
                $scope.firstVisit = $scope.visit.patient.toBeVerified;
            }

            $scope.previewOnly = ($scope.visit.doctor.id != userModel.currentUser.id);
        }

        function setPermissions() {
        }

        function setListeners() {
            // fixme - unused listener?
            $scope.$on(Event.CHRONIC_AND_PAST_ILLNESS.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.chronicIllnesses = dataPage.data.filter(function(element) {
                    return element.chronic;
                });
            });

            $scope.$on(Event.ALLERGY.GET_DATA_PAGE.SUCCESS, function(event, dataPage) {
                $scope.allergies = dataPage.data.filter(function(element) {
                    return element.type != Enum.ALLERGY_TYPE.PATIENT_CLAIMS_NO_ALLERGIES;
                });
            });

            $scope.$on(Event.PATIENT.GET_BY_ID.SUCCESS, function (event, patient) {
                $scope.visit.patient = patient;
            });

            listeners.onGetLastVisitForPatient = function (visit) {
                $scope.lastPatientVisit = visit;

                if(visit.visitCard && visit.visitCard.id) {
                    visitCardModel.getById(visit.visitCard.id).then(listeners.onGetVisitCardById);
                }
            };

            listeners.onGetVisitCardById = function (visitCard) {
                $scope.visitCard = visitCard;

                if(visitCard.diagnosisList.length) {
                    $scope.mainAfflictionFromLastVisit = visitCard.diagnosisList.filter(function(element) {
                        return element.mainAffliction;
                    })[0];
                }
            }
        }

        function setActions() {
            $scope.viewVisitCard = function() {
                $mdDialog.cancel();
                $timeout(function () {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_VIEW, { patientId: $scope.visit.patient.id, visitId: $scope.visit.id });
                });
            };

            $scope.fillVisitCard = function() {
                $mdDialog.cancel();
                $timeout(function () {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, { patientId: $scope.visit.patient.id, visitId: $scope.visit.id });
                });
            };

            $scope.fillPatientDataBeforeVisitStart = function() {
                $mdDialog.cancel();
                $timeout(function () {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, { patientId: $scope.visit.patient.id, visitId: $scope.visit.id });
                });
            };

            $scope.printEpicrisis = function () {
                visitCardModel.downloadPDF($scope.visit.visitCard.id);
            };

            $scope.downloadEpicrisisForLastPatientVisit = function () {
                visitCardModel.downloadPDF($scope.lastPatientVisit.visitCard.id);
            };


            $scope.updateVisit = function(visit) {
                if(visit.visitStatus === Enum.VISIT_STATUS.PLANNED || visit.visitStatus === Enum.VISIT_STATUS.SUSPENDED) {
                    $state.go(Constant.STATE.APP.VISIT.EDIT, {visitId: visit.id});
                }
            };

            $scope.cancelVisit = function () {
                var confirm = $mdDialog.confirm({
                    title: $translate.instant('T.MODULE.VISIT.CANCEL_VISIT_CONFIRMATION'),
                    ok: $translate.instant('T.UI.APPLICATION.YES'),
                    cancel: $translate.instant('T.UI.APPLICATION.NO')
                });
                $mdDialog.show(confirm).then(function() {
                    visitModel.cancel($scope.visit);
                }, function() {
                    return false;
                });
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {
            //chronicAndPastIllnessModel.getDataPage($scope.chronicAndPastIllnessCriteria);

            if(userModel.userHasRight(Constant.RIGHT.PATIENTS_STATE_OF_HEALTH_READ)) {
                allergyModel.getDataPage($scope.allergyCriteria);
            }
            if(userModel.getCurrentContextDoctorId()) {
                visitModel.getLastVisitForPatient($scope.patientId, userModel.getCurrentContextDoctorId()).then(listeners.onGetLastVisitForPatient);
            }



            patientModel.getById($scope.patientId);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);